import type { AdapterMeta } from "@repo/adapter-core";

export const BELLE_PROPERTY_META: AdapterMeta = {
  slug: "belle-property",
  name: "Belle Property",
  baseUrl: "https://www.belleproperty.com",
  description: "Premium Eastern suburbs specialist with luxury residential sales coverage.",
  supportedStates: ["NSW", "VIC", "QLD"],
  urlPattern: /belleproperty\.com\/listings\/[a-z0-9-]+/i,
  sourceType: "agency",
};
